import { NotImplementedError } from "../utils/Error";
import { PAL } from "./PlatformAdapters";
export class FileSystemAdapter {
    readFile(path, encoding) {
        throw new NotImplementedError();
    }
    writeFile(path, data, encoding) {
        throw new NotImplementedError();
    }
    unlink(path) {
        throw new NotImplementedError();
    }
    copyFile(srcPath, destPath) {
        throw new NotImplementedError();
    }
    exists(path) {
        throw new NotImplementedError();
    }
    getFileSize(path) {
        throw new NotImplementedError();
    }
    mkdir(path, options) {
        throw new NotImplementedError();
    }
    rmdir(path, options) {
        throw new NotImplementedError();
    }
    readdir(path) {
        throw new NotImplementedError();
    }
    unzip(zipFilePath, targetPath) {
        throw new NotImplementedError();
    }
}
PAL.register("fs", FileSystemAdapter);
